// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/catalog/_index.scss
// module id = 64
// module chunks = 0